// extracted by mini-css-extract-plugin
module.exports = {"mobile-header":"mobile-header___VvdDl","back-link":"back-link___3zSGs","title":"title___jx3PP","right-action":"right-action___36f9u"};